import { render } from "./JadwalLab.vue?vue&type=template&id=6d373850"
import script from "./JadwalLab.vue?vue&type=script&lang=js"
export * from "./JadwalLab.vue?vue&type=script&lang=js"

import "./JadwalLab.vue?vue&type=style&index=0&id=6d373850&lang=sass"

import exportComponent from "/master/future-project/mts/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QInnerLoading,QSpinnerIos,QTd,QAvatar});
